"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class SidebarHeader extends React.PureComponent {
    render() {
        const { title, children } = this.props;
        return (React.createElement("div", { className: 'vf-sidebar__header' },
            React.createElement("div", { className: 'title vf-upper' }, title),
            React.createElement("div", { className: 'content vf-clearfix' }, children)));
    }
}
exports.default = SidebarHeader;
